export default __webpack_public_path__ + "7647374776fe96032f2720a7f164cd7a.svg";